export default "__VITE_ASSET__Cvo2p$Eo__"